import { SVGProps } from "react";

export const JiraMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M27.3392 4H15.0986C15.0986 6.99443 17.575 9.43176 20.6175 9.43176H22.8817V11.5557C22.8817 14.5501 25.3581 16.9875 28.4005 16.9875V5.04457C28.4005 4.45265 27.9406 4 27.3392 4Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M21.2899 9.98877H9.04932C9.04932 12.9832 11.5257 15.4205 14.5682 15.4205H16.8323V17.5793C16.8323 20.5737 19.3088 23.0111 22.3512 23.0111V11.0333C22.3512 10.4762 21.8913 9.98877 21.2899 9.98877Z"
                fill="#1868DB"
            />
            <path
                id="Vector_3"
                d="M15.2406 16.0127H3C3 19.0071 5.47641 21.4444 8.51887 21.4444H10.783V23.5684C10.783 26.5628 13.2594 29.0002 16.3019 29.0002V17.0573C16.3019 16.4653 15.8066 16.0127 15.2406 16.0127Z"
                fill="url(#paint0_linear_1273_1197)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_1273_1197"
                x1="16.3817"
                y1="16.0527"
                x2="10.4576"
                y2="21.9092"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.176" stopColor="#0052CC" />
                <stop offset="1" stopColor="#2684FF" />
            </linearGradient>
        </defs>
    </svg>
);
